const setAppDimensions = (appWidth, appHeight) => (
  {
    type: 'SET_APP_DIMENSIONS',
    data: {appWidth, appHeight}
  }
);

const setAppView = (appView) => (
  {
    type: 'SET_APP_VIEW',
    data: {appView}
  }
);

const setSideNavOpen = (sideNavOpen) => (
  {
    type: 'SET_SIDE_NAV_OPEN',
    data: {sideNavOpen}
  }
);

const setLoggedInUser = (loggedInUser) => (
  {
    type: 'SET_LOGGED_IN_USER',
    data: {loggedInUser}
  }
);

const setLoggedInUserAccount = (loggedInUserAccount) => (
  {
    type: 'SET_LOGGED_IN_USER_ACCOUNT',
    data: {loggedInUserAccount}
  }
);

const setViewingUserAccount = (viewingUserAccount) => (
  {
    type: 'SET_VIEWING_USER_ACCOUNT',
    data: {viewingUserAccount}
  }
);

const setViewingUserCategories = (viewingUserCategories) => (
  {
    type: 'SET_VIEWING_USER_CATEGORIES',
    data: {viewingUserCategories}
  }
);

const setViewingUserFriends = (viewingUserFriends) => (
  {
    type: 'SET_VIEWING_USER_FRIENDS',
    data: {viewingUserFriends}
  }
);

const setViewingUserTrips = (viewingUserTrips) => (
  {
    type: 'SET_VIEWING_USER_TRIPS',
    data: {viewingUserTrips}
  }
);

const setViewingUserTags = (viewingUserTags) => (
  {
    type: 'SET_VIEWING_USER_TAGS',
    data: {viewingUserTags}
  }
);

const setViewingUserEvents = (viewingUserEvents) => (
  {
    type: 'SET_VIEWING_USER_EVENTS',
    data: {viewingUserEvents}
  }
);

const setMap = (map, mapLibrary, markerLibrary, placesLibrary, coreLibrary) => (
  {
    type: 'SET_MAP',
    data: {map, mapLibrary, markerLibrary, placesLibrary, coreLibrary}
  }
);

const setSearchInput = (searchInput) => (
  {
    type: 'SET_SEARCH_INPUT',
    data: {searchInput}
  }
);

const setDialogOpen = (dialogOpen, dialogData = {}) => (
  {
    type: 'SET_DIALOG_OPEN',
    data: {dialogOpen, dialogData}
  }
);

const setSelectedEvent = (event) => (
  {
    type: 'SET_SELECTED_EVENT',
    data: {event}
  }
);

const setFilters = (selectedCategoryIds, selectedFriendIds, selectedTagIds, selectedTripIds, selectedStartDate, selectedEndDate) => (
  {
    type: 'SET_FILTERS',
    data: {selectedCategoryIds, selectedFriendIds, selectedTagIds, selectedTripIds, selectedStartDate, selectedEndDate}
  }
);

const setEmbed = (embed) => (
  {
    type: 'SET_EMBED',
    data: {embed}
  }
);

const setHideHeader = (hideHeader) => (
  {
    type: 'SET_HIDE_HEADER',
    data: {hideHeader}
  }
);

const setSelectedGroup = (group) => (
  {
    type: 'SET_SELECTED_GROUP',
    data: {group}
  }
);

const setShowResetView = (showResetView) => (
  {
    type: 'SET_SHOW_RESET_VIEW',
    data: {showResetView}
  }
);

const triggerMapReset = () => (
  {
    type: 'TRIGGER_MAP_RESET'
  }
);

export {
  setMap,
  setSearchInput,
  setDialogOpen, 
  setLoggedInUser, 
  setLoggedInUserAccount, 
  setViewingUserAccount,
  setViewingUserFriends,
  setViewingUserCategories,
  setViewingUserTrips,
  setViewingUserTags,
  setViewingUserEvents,
  setAppDimensions,
  setSelectedEvent,
  setFilters,
  setEmbed,
  setHideHeader,
  setSelectedGroup,
  setShowResetView,
  triggerMapReset,
  setAppView,
  setSideNavOpen
}
